import { createContext } from 'react';

import { IBMenuItem } from '@totem/components/ui_components/menus/types';

interface Context {
  mainMenu: IBMenuItem[];
}

export const initialState: Context = {
  mainMenu: [],
};

export default createContext<Context>(initialState);
